// L'agregateur d'un mandat, choisi AVANT la signature (chantier C8a, 15/10/2026).
//
// POURQUOI AVANT : un actif declare a un agregateur l'est pour toujours (contrat K1), et
// Symphonics exige un mandat signe AVEC lui. Le mandat doit donc savoir a qui il
// s'adresse au moment ou le client signe ; le serveur en deduit la piece a faire signer
// et refusera ensuite de declarer l'actif ailleurs.
//
// « Mandat generique » reste le premier choix et la valeur par defaut : c'est le
// comportement d'avant, celui de tout mandat deja signe. Qui choisit, et quand, est une
// question ouverte a David ; ces ecrans en portent la mecanique, pas la regle.
//
// La liste suit `services/mandat_agregateur.AGREGATEURS_MANDAT` cote serveur, qui reste
// juge : une valeur inconnue y est refusee (400), jamais devinee.

export const OPTIONS_AGREGATEUR_MANDAT = [
  { valeur: '', libelle: 'Mandat générique (aucun agrégateur)' },
  { valeur: 'survoltage', libelle: 'Survoltage' },
  { valeur: 'symphonics', libelle: 'Symphonics' },
];

// Le mot a ressaisir pour rendre un gabarit generique (`gabarits_agregateur.MOT_GENERIQUE`).
export const MOT_GENERIQUE = 'générique';

// `null` et non `''` : le serveur lit « absent » comme un mandat generique, et une
// chaine vide partout ailleurs serait une valeur de plus a comprendre.
export const choixEnvoye = (choix) => (choix ? String(choix) : null);

// Le canal QR est rempli par le CLIENT : l'agregateur n'y vient que du lien SIGNE que
// l'operateur a genere (`services/lien_qr_agregateur`). Le jeton part tel quel, sans
// retouche : c'est le serveur qui verifie la signature et refuse un lien altere.
export function jetonAgregateurDepuisUrl(recherche) {
  const valeur = new URLSearchParams(recherche || '').get('agregateur');
  return valeur ? valeur.trim() : null;
}

// Le serveur rend un chemin (`/onboarding?...`) : l'adresse a imprimer est celle du site
// ouvert par l'operateur, qui est aussi celui du formulaire public.
export const lienComplet = (origine, chemin) => `${String(origine || '').replace(/\/$/, '')}${chemin}`;

export const libelleAgregateur = (nom) => (
  OPTIONS_AGREGATEUR_MANDAT.find((o) => o.valeur && o.valeur === nom)?.libelle || ''
);

// Rattacher un gabarit se confirme en ressaisissant son futur destinataire.
export const confirmationAttendue = (cible) => cible || MOT_GENERIQUE;

const normaliser = (texte) => String(texte || '').normalize('NFD')
  .replace(/[̀-ͯ]/g, '').trim().toLowerCase();

export const saisieConforme = (saisie, cible) => (
  Boolean(normaliser(saisie)) && normaliser(saisie) === normaliser(confirmationAttendue(cible))
);

// Etat d'un gabarit dans l'ecran admin. Le BROUILLON suit la piece, pas son rattachement :
// une piece dediee rendue generique reste un brouillon tant qu'elle n'est pas validee.
export function etatGabarit(gabarit) {
  if (gabarit?.brouillon) return 'brouillon';
  return gabarit?.agregateur ? 'valide' : 'generique';
}
